import requestManager from '../../../api/requestManager';

const createDeviceData = () => requestManager.apiPost(`/v1/users/create_device_data/`, {});

const getSyndicateUserDetails = () => requestManager.apiGet(`/v1/syndicates/get_syndicate_user_details/`);

const exitImpersonation = (body: any) => requestManager.apiPut('/v1/admin/impersonate/exit_impersonation/', body);

export default { createDeviceData, getSyndicateUserDetails, exitImpersonation };
